import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { handleLoginSubmit } from "../../redux/modules/auth/actions";
import { Link } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Link as RouterLink, Redirect } from "react-router-dom";
import { RenderField } from "../../components/RenderField";
import useForm from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "../../components/Card";

const styles = () => ({
  header: {
    marginBottom: 30
  },
  subheader: {
    marginBottom: 10
  },
  input: {
    marginBottom: 30
  }
});

export const LoginForm = withStyles(styles)(({ classes }) => {
  const dispatch = useDispatch();
  const error = useSelector(state => state.auth.error);
  const { register, handleSubmit } = useForm();
  const loggedIn = useSelector(state => !!state.auth.token);

  const onSubmit = data => {
    dispatch(handleLoginSubmit(data));
  };

  if(loggedIn){
    return <Redirect to="/map"/>
  }

  return (
    <Card>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              className={classes.header}
              component="h1"
              variant="h4"
              align="left"
            >
              Войти
            </Typography>
            <Typography
              className={classes.subheader}
              component="p"
              align="left"
            >
              Новый пользователь?{" "}
              <Link component={RouterLink} to="/signup">
                Зарегистрируйтесь
              </Link>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <RenderField
              error={!!error}
              helperText={error}
              className={classes.input}
              required
              name="email"
              label="Имя пользователя"
              color="secondary"
              inputRef={register}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <RenderField
              error={!!error}
              helperText={error}
              className={classes.input}
              required
              name="password"
              type="password"
              label="Пароль"
              inputRef={register}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} align="right">
            <Button variant="contained" color="primary" type="submit">
              Войти
            </Button>
          </Grid>
        </Grid>
      </form>
    </Card>
  );
});
